import React from "react";
import { useParams, useLocation } from 'react-router-dom';

const OrderDetails = () => {
  const { orderID } = useParams;
  const location = useLocation();
  const order = location.state?.order;

  const subTotal = order ? order.totalAmount * order.quantity : 0;
  const cgst = subTotal * 0.09; // 9% fixed
  const sgst = subTotal * 0.09; // 9% fixed
  const shipping = 1200; // fixed 
  const grandTotal = subTotal + cgst + sgst + shipping;

  const formatOrderDate = (dateString) => {
    const options = { day: '2-digit', month: 'long', year: 'numeric' };
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-IN', options).format(date);
  };

  return (
    <div className="w-full h-[1200px] flex items-center justify-center">
      <div className="w-[1014px] h-[935px] bg-[#FFF9F2] rounded-r-[10px] flex flex-col px-[30px] pt-[50px] items-center gap-y-[20px]">
        <div className="w-[954px] h-[121px] rounded-[10px] bg-white py-[25px] pl-[26px] pr-[35px] flex flex-row items-center justify-between gap-x-[24px] drop-shadow-[0_0px_2px_rgba(0,0,0,0.10)]">
          <img
            src={order?.images[0]}
            alt=""
            className="w-[57px] h-[69px]"
          />
          <div className="flex items-center justify-between flex-row w-full">
            <div className="flex flex-col items-start justify-between h-[67px]">
              <h4 className="w-[301px] h-[24px] text-start text-black font-semibold text-[16px]">
                {order?.productTitle}
              </h4>
              <div className="flex flex-row w-[315px] gap-x-[16px] items-center justify-start">
                <p className="w-[143px] h-[35px] rounded-[5px] bg-[#F2F2F2] flex items-center justify-center text-black font-medium text-[14px]">
                  Quantity :{" "}
                  <span className="text-black font-semibold text-[14px]">
                    {order?.quantity} Units
                  </span>
                </p>
                <p className="w-[140px] h-[21px] font-medium text-[14px] text-start text-black">
                  Order ID : {order?.orderID}
                </p>
              </div>
            </div>
            <div className="flex flex-col items-end justify-between h-[57px]">
              <p className="w-[105px] h-[24px] font-medium text-black text-end text-[16px]">
                Order Value :
              </p>
              <p className="w-[70px] h-[24px] font-semibold text-[16px] text-end text-black">
                ₹ {order?.totalAmount}
              </p>
            </div>
          </div>
        </div>

        <div className="w-[954px] h-[435px] rounded-[10px] bg-white pt-[19px] pl-[24px] pr-[35px] pb-[23px] flex flex-row drop-shadow-[0_0px_2px_rgba(0,0,0,0.10)]">
          <div className="flex flex-col">
            <h3 className="w-[107px] h-[24px] text-black text-start font-semibold text-[16px]">
              Order Details
            </h3>
            <hr className="w-[163px] h-[2px] bg-[#FF6300] mt-[9px]" />
            <div className="flex flex-wrap w-[446px] h-auto mt-[22px] justify-between">
              <div className="w-[262px] h-[75px] flex flex-col items-start justify-between">
                <h4 className="w-[94px] h-[21px] font-semibold text-[14px] text-start text-black">
                  Buyer Details
                </h4>
                <p className="w-[141px] h-[54px] text-start text-black font-medium text-[14px] leading-[30px]">
                 {order?.name}. Phone :{order?.buyerPhoneNumber}
                </p>
              </div>

              <div className="w-[125px] h-[51px] flex flex-col items-start gap-y-[4px]">
                <h4 className="w-[85px] h-[21px] font-semibold text-[14px] text-start text-black">
                  Order Date :
                </h4>
                <p className="w-[125px] h-[23px] text-start text-black font-medium text-[14px]">
                  {formatOrderDate(order?.orderDate)}
                </p>
              </div>

              <div className="w-[262px] h-[160px] flex flex-col items-start justify-between mt-[40px]">
                <h4 className="w-[127px] h-[21px] font-semibold text-[14px] text-start text-black">
                  Delivery Address :
                </h4>
                <p className="w-[262px] h-[135px] text-start text-black font-medium text-[14px] leading-[32px]">
                {order?.shippingAddress}  City :{order?.city} State :
                {order?.state} Phone :{order?.buyerPhoneNumber} Pincode : 400002
                </p>
              </div>
            </div>
          </div>

          <div className="w-[67px] h-full flex items-center justify-center">
            <hr className="w-[0.5px] h-full bg-[#D8D8D8]" />
          </div>

          <div className="container mx-auto flex flex-col">
            <h3 className="w-[139px] h-[24px] font-semibold text-[16px] text-start text-black">
              Payment Details
            </h3>

            <hr className="w-[166px] h-[2px] rounded-full bg-[#FF6300] mt-[9px]" />

            <div className="w-full h-auto mt-[14px]">
              <div className="grid grid-cols-1 md:grid-cols-2">
                <div className="font-medium text-[14px] text-black">
                  <p className="w-[104px] h-[21px] text-start">
                    Product Price:
                  </p>
                  <p className="w-[88px] h-[25px] bg-[#F0F0F0] rounded-[5px] flex items-center justify-center mt-[4px]">
                    Quantity:
                  </p>
                </div>
                <div className="font-medium text-[14px] text-black">
                  <p className="w-full h-[21px] text-end">₹ {order?.totalAmount}</p>
                  <div className="flex items-center justify-end">
                    <p className="w-[31px] h-[25px] bg-[#F0F0F0] rounded-[5px] flex items-center justify-center mt-[4px]">
                      x {order?.quantity}
                    </p>
                  </div>
                </div>
                <div className="mt-[19px]">
                  <p className="w-[70px] h-[21px] text-[14px] font-semibold text-start text-black">
                    Subtotal:
                  </p>
                </div>
                <div className="mt-[19px]">
                  <p className="h-[21px] text-[14px] font-semibold text-end text-black">
                    ₹ {subTotal.toFixed(2)}
                  </p>
                </div>
              </div>

              <hr className="mt-[12px] bg-[#D8D8D8] w-full h-[1px]" />

              <div className="grid grid-cols-1 md:grid-cols-2">
                <div className="font-medium text-[14px] text-black">
                  <p className="w-[72px] h-[21px] text-start font-medium text-[14px] text-black mt-[20px]">
                    Shipping:
                  </p>
                  <p className="w-[82px] h-[21px] text-start mt-[8px]">
                    CGST (9%):
                  </p>
                </div>
                <div className="font-medium text-[14px] text-black">
                  <p className="w-full h-[21px] font-medium text-end mt-[20px]">
                    ₹ {shipping}
                  </p>

                  <p className="w-full h-[21px] font-medium text-end mt-[8px]">
                    ₹ {cgst.toFixed(2)}
                  </p>
                </div>
                <div className="font-medium text-[14px] text-black">
                  <p className="w-[79px] h-[21px] text-start mt-[8px]">
                    SGST (9%):
                  </p>
                  <p className="w-[133px] h-[21px] text-start mt-[8px]">
                    Payment Method:
                  </p>
                </div>
                <div className="font-medium text-[14px] text-black">
                  <p className="w-full h-[21px] font-medium text-end mt-[8px]">
                    ₹ {sgst.toFixed(2)}
                  </p>

                  <p className="w-full h-[21px] font-medium text-end mt-[8px]">
                    UPI Payment
                  </p>
                </div>
                <div className="font-semibold text-[18px] text-black mt-[26px]">
                  <p className="w-[108px] h-[24px] font-semibold text-[16px] text-start">
                    Grand Total
                  </p>
                </div>
                <div className="text-[#FF6300] mt-[26px]">
                  <p className="w-full h-[27px] font-semibold text-[18px] text-end">
                    ₹ {grandTotal.toFixed(2)}
                  </p>
                </div>
              </div>
            </div>
            <div className="w-full flex items-center justify-center mt-[22px]">
              <button className="w-[150px] h-[37px] font-semibold text-[14px] text-white rounded-[5px] bg-[#FF6300]">
                Download Invoice
              </button>
            </div>
          </div>
        </div>

        <div className="w-[954px] h-[247px] rounded-[10px] bg-white py-[25px] pl-[26px] pr-[35px] flex flex-col gap-x-[24px] drop-shadow-[0_0px_2px_rgba(0,0,0,0.10)]">
          <div className="flex flex-row items-center justify-between w-full">
            <h4 className="w-[116px] h-[24px] font-semibold text-[16px] text-black text-start">
              Track Delivery
            </h4>
            <p className="w-[139px] h-[21px] font-semibold text-[14px] text-black text-start">
              Order ID :{" "}
              <span className="text-[14px] font-semibold text-black">
                {order?.orderID}
              </span>
            </p>
          </div>

          <hr className="w-[185px] bg-[#FF6300] rounded-full h-[1px] pb-[3px] mt-[5px]" />
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
